import { cookieStorage } from '@pflegia/ui/storage/cookie-storage';

import { POSTHOG_COOKIE_KEY } from '../constants';

export const getValidPosthogDistinctId = (distinctId: unknown): string | undefined =>
  typeof distinctId === 'string' && distinctId.trim() ? distinctId : undefined;

export const getDistinctIdFromPosthogBootstrapCookie = (cookieValue: string | null | undefined): string | undefined => {
  if (!cookieValue) return undefined;

  try {
    return getValidPosthogDistinctId(JSON.parse(cookieValue).distinctID);
  } catch {
    return undefined;
  }
};

export const getBrowserPosthogDistinctId = (posthogDistinctId?: unknown): string | undefined => {
  if (globalThis.window === undefined) {
    return getValidPosthogDistinctId(posthogDistinctId);
  }

  return getValidPosthogDistinctId(posthogDistinctId) ?? getDistinctIdFromPosthogBootstrapCookie(cookieStorage.getItem(POSTHOG_COOKIE_KEY));
};
